import React from 'react';
import './mentoringReels.css';

const REEL_IDS = [
  '1363921005724492',
  '3390562177792833',
  '4237721836518442',
  '1614922113597798',
  '2527862284386660',
  '1753802429208480',
  '1092012433333167',
];

const reelUrl = (id) => `https://web.facebook.com/reel/${id}/`;
const embedUrl = (id) => `https://www.facebook.com/plugins/video.php?height=476&href=${encodeURIComponent(reelUrl(id))}&show_text=false&width=267&t=0`;

/** The same seven source videos appear on the mentoring landing page and home. */
export default function MentoringReels({ locale = 'fr', surface = 'page' }) {
  const isEnglish = locale === 'en';
  const Heading = surface === 'home' ? 'h3' : 'h2';
  const headingId = `mentoring-reels-${surface}`;

  return (
    <section className={`mt-reels mt-reels--${surface}`} aria-labelledby={headingId}>
      <div className="mt-reels__inner">
        <div className="mt-reels__intro">
          <p className="mt-reels__eyebrow">{isEnglish ? 'Mentoring in action' : 'Le mentorat en images'}</p>
          <Heading id={headingId}>{isEnglish ? 'See the program in action.' : 'Découvrez le programme en vidéo.'}</Heading>
        </div>
        <div className="mt-reels__grid">
          {REEL_IDS.map((id, index) => (
            <div className="mt-reels__item" key={id}>
              <iframe
                src={embedUrl(id)}
                title={isEnglish ? `Mentoring video ${index + 1}` : `Vidéo de mentorat ${index + 1}`}
                width="267"
                height="476"
                loading="lazy"
                scrolling="no"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                allowFullScreen
              />
              <a href={reelUrl(id)} target="_blank" rel="noopener noreferrer">
                {isEnglish ? 'Watch on Facebook' : 'Voir sur Facebook'} ↗
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
